<template>
  <!-- 2d6fb3 -->
  <el-row class="headMenuBox" type="flex" justify="space-between">
    <el-col :span="7">
      <img src="./../../../assets/img/logo1.png" alt="" />
    </el-col>
    <el-col :span="10">
      <el-menu
        active-background-color="#2d6fb3"
        background-color="#409eff"
        text-color="#fff"
        active-text-color="#fff"
        mode="horizontal"
        :default-active="activeMenu"
      >
        <template v-for="item in getMenu">
          <el-submenu
            v-if="item.children.length !== 0"
            :index="item.url"
            :key="item.menuId"
          >
            <template slot="title">{{ item.menuName }}</template>
            <el-menu-item
              v-for="child in item.children"
              :index="child.url"
              :key="child.menuId"
              @click="goTo(child.url)"
              >{{ child.menuName }}</el-menu-item
            >
          </el-submenu>
          <el-menu-item
            v-else
            :index="item.url"
            :key="item.menuId"
            @click="goTo(item.url)"
            >{{ item.menuName }}</el-menu-item
          >
        </template>
      </el-menu>
    </el-col>
    <el-col :span="7" style="text-align:right;padding-right:20px">
      <template v-if="getRoleType != 0">
        <el-dropdown @command="downloadFile">
          <el-button
            type="text"
            icon="iconfont pro-icon-ziliaoshouce"
            class="navBut"
            >操作指南</el-button
          >
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="getRoleType == 1" :command="1"
              >考点/报考点操作指南</el-dropdown-item
            >
            <el-dropdown-item v-if="getRoleType == 2" :command="2"
              >考生操作指南</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <el-button type="text" class="navBut"
        >欢迎&nbsp;&nbsp;{{ getName }} （<span class="getName" :title="getRoleName">
          <!-- <el-tooltip
            class="item"
            effect="dark"
            content="getRoleName"
            placement="bottom"
          >
            {{ getRoleName }}
          </el-tooltip>  -->
             {{ getRoleName }}
          </span
        >） 登录！</el-button
      >
      <el-button
        type="text"
        icon="iconfont pro-icon-xiugaimima"
        @click="visible = true"
        class="navBut"
        >修改密码</el-button
      >
      <el-button
        type="text"
        @click="loginOut"
        icon="iconfont pro-icon-tuichu"
        class="navBut"
        >退出</el-button
      >
    </el-col>
    <el-dialog
      custom-class="dailogComponents"
      title="修改密码"
      :visible.sync="visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      v-if="visible"
      width="300px"
    >
      <div class="dialogBox">
        <el-row type="flex" justify="space-between">
          <el-col :span="10">
            <p class="titleP">用户名：</p>
          </el-col>
          <el-col>
            <p>
              {{ getUserInfo.userName }}
            </p>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="10">
            <p class="titleP">姓名：</p>
          </el-col>
          <el-col>
            <p>
              {{ getUserInfo.name }}
            </p>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="10">
            <p class="titleP">原密码：</p>
          </el-col>
          <el-col>
            <el-input
              v-model="passwordConfirm"
              size="small"
              show-password
              placeholder="请输入原密码"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="10">
            <p class="titleP">新密码：</p>
          </el-col>
          <el-col>
            <el-input
              v-model="password"
              size="small"
              show-password
              placeholder="请输入新密码"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="10">
            <p class="titleP">确认密码：</p>
          </el-col>
          <el-col>
            <el-input
              v-model="rePassword"
              size="small"
              show-password
              placeholder="请再次输入密码"
            ></el-input>
          </el-col>
        </el-row>

        <el-row type="flex" class="dailogButBox" justify="center">
          <el-button
            size="medium"
            @click="
              visible = false;
              password = '';
              rePassword = '';
              passwordConfirm = '';
            "
            >取消</el-button
          >
          <Debounce>
            <el-button size="medium" type="primary" @click="submit"
              >确认</el-button
            >
          </Debounce>
        </el-row>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
export default {
  computed: {
    getMenu() {
      return this.$store.state.menu.menuList;
    },
    activeMenu() {
      return this.$route.path;
    },
    getName() {
      let name = this.$store.state.user.user.name;
      if (!name) {
        return "----";
      }
      return name;
    },
    getRoleName() {
      let roleInfo = this.$store.state.user.user.roleInfo;
      if (!roleInfo || roleInfo.length == 0) {
        return "----";
      }
      return roleInfo
        .map((i) => {
          return i.roleName;
        })
        .join(",");
    },
    getUserInfo() {
      return this.$store.state.user.user;
    },
    getRoleType() {
      let type = 0;
      try {
        let roleList = this.$store.state.user.user.roleIdList
          ? this.$store.state.user.user.roleIdList
          : [];
        roleList.find((item) => {
          if (item == 3 || item == 4) {
            type = 1;
          } else if (type == 6) {
            type = 2;
          } else {
            type = 0;
          }
        });
      } catch (error) {
        type = 0;
      }

      return type;
    },
  },
  data() {
    return {
      visible: false,
      password: "",
      rePassword: "",
      passwordConfirm: "",
      examFile: null,
      stuFile: null
    };
  },
  async created() {
    await this.loadMenuList();
    this.getFile();
  },
  methods: {
    goTo(path) {
      this.$router.push({ path });
    },
    loginOut() {
      this.$dailog({
        title: "退出",
        context: "是否退出当前账号?",
        callbackFun: () => {
          this.$axios.get("/login/logout").then((res) => {
            this.$message({
              type: "success",
              message: "退出成功!",
              duration: 1000,
            });
            this.$router.push({ path: "/login" });
          });
        },
      });
    },
    loadMenuList() {
      this.$axios.get("menu/user").then((res) => {
        let data = res.data.data;
        if (data.length == 0) {
          this.$message({
            type: "warning",
            duration: 1000,
            message: "当前用户无权限，请联系管理员!",
            onClose: () => {
              this.$router.push({ path: "/login" });
            },
          });
          return;
        }
        let list = [];
        data.filter((item) => {
          list.push(item.url);
          if (item.children.length !== 0) {
            item.children.map((tree) => {
              list.push(tree.url);
            });
          }
        });
        this.$store.commit("setMentForUser", list);
        this.$store.commit("setMenuList", data);
      });
    },
    submit() {
      let passTest = /^(\w){6,12}$/; //密码正则
      if (!passTest.test(this.password)) {
        this.$message.warning({
          message: "请填写6-12位密码！",
          duration: 1000,
        });
        this.isModal = true;
        return;
      }
      if (this.password !== this.rePassword) {
        this.$message.warning({
          message: "两次密码必须一致！",
          duration: 1000,
        });
        return;
      }
      this.$axios
        .post("centre/pwd", {
          password: this.password,
          userId: this.$store.getters.getUser.userId,
          passwordConfirm: this.passwordConfirm,
        })
        .then((res) => {
          this.$message.success({ message: "修改成功!", duration: 1000 });
          this.visible = false;
          this.password = "";
          this.rePassword = "";
          this.passwordConfirm = "";
        });
    },
    getFile() {
      this.$axios.get("upload/getGuide?type=" + [3, 4, 6]).then((res) => {
        let { data } = res.data;
        let examFile = data.find((item) => item.roles == "3,4");
        let stuFile = data.find((item) => item.roles == "6");
        this.examFile = examFile ? examFile : null;
        this.stuFile = stuFile ? stuFile : null;
      });
    },
    downloadFile(val) {
      let url = val == 1 ? this.examFile.guideUrl : this.stuFile.guideUrl;
      window.open(url);
    },
  },
};
</script>
<style lang="scss">
.headMenuBox {
  .el-menu {
    .el-submenu {
      .el-submenu__title {
        .el-icon-arrow-down {
          color: #fff !important;
        }
      }
    }
    .is-active {
      .el-submenu__title {
        border-bottom-color: #2d6fb3 !important;
        background-color: #2d6fb3 !important;
      }
    }
    .el-menu-item.is-active {
      border-bottom-color: #2d6fb3 !important;
      background-color: #2d6fb3 !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.headMenuBox {
  background-color: #409eff;
  height: 60px;
  overflow: hidden;
  img {
    height: 60px;
  }
  .navBut {
    color: #fff;
    margin-top: 10px;
    margin-left: 20px;
    // overflow: hidden;
  }
  .dialogBox {
    .el-row {
      margin-bottom: 5px;
      padding: 0px 10px;
      .titleP {
        text-align: right;
        font-weight: bold;
      }
      p {
        line-height: 2;
      }
    }
    .dailogButBox {
      padding-top: 10px;
      margin-bottom: 0px;
    }
  }
}
</style>
<style lang="scss">
.headMenuBox {
  .iconfont {
    margin-right: 5px;
  }
}
.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 140px !important;
}
.el-button navBut el-button--text {
  height: 50px;
  span {
    height: 100%;
  }
}
.getName {
  display: -moz-inline-box;
  display: inline-block;
  width: 84px !important;
  height: 20px;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  top:6px
}
</style>
